/**
 * @file Builds the contact-us inputs for a signed-in investor.
 */
import type { SchemaInput } from "@api";
import { TYPE_STRING } from "@components/Form";

/**
 * Returns the investor contact-us inputs.
 */
const getInvestorInputs = (): SchemaInput[] => {
  return [
    {
      name: "subject",
      type: TYPE_STRING,
      placeholder: "Subject of your request",
    },
    {
      name: "message",
      placeholder: "",
      inputProps: {
        rows: 5,
      },
    },
  ];
};

export default getInvestorInputs;
